import React, { useEffect } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { IconReloadLarge, spacing } from "@izettle/otto"
import { Text, Icon } from "@izettle/react"

import { Cancel } from "@/components/cancel"
import { Error } from "@/components/error"
import { FileSelector } from "@/components/file-selector"
import { PageWrapper } from "@/components/layout-helpers"
import { useSetPageTitle } from "@/components/page-title"
import { baseUrl } from "@/constants"
import { useThemeInfo } from "@/hooks/use-theme-info"
import { SelectFilesProps } from "@/models"

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacing.xLarge};
  margin-bottom: ${spacing.xLarge};
`

const FlipIcon = styled(Icon)`
  margin-bottom: ${spacing.small};
`

const PageTitle = styled(Text.Title3)`
  margin-top: ${spacing.xxSmall};
  margin-bottom: ${spacing.tiny};
  text-align: center;
`

const InfoText = styled(Text.Regular)`
  text-align: center;
  margin-bottom: ${spacing.none};
`

type FlipYourCardProps = {
  isDoubleSided: boolean
  selectFiles: SelectFilesProps
}

export const FlipYourCard: React.FC<FlipYourCardProps> = ({
  isDoubleSided,
  selectFiles,
}) => {
  const { text } = useLocalization()
  const { setPageTitle } = useSetPageTitle()

  const {paypalTheme} = useThemeInfo()

  useEffect(() => {
    setPageTitle(text("PROOF_OF_IDENTITY"))
  }, [])

  if (!isDoubleSided) return <Error cancelUrl={`${baseUrl}/proofOfIdentity`} />

  return (
    <PageWrapper>
      <Cancel url={`${baseUrl}/proofOfIdentity`} />
      <ContentWrapper>
        <FlipIcon svgIcon={IconReloadLarge} color={paypalTheme ? "default" : "action"} />
        <PageTitle>{text("PROOF_OF_IDENTITY_FLIP_YOUR_CARD_TITLE")}</PageTitle>
        <InfoText>{text("PROOF_OF_IDENTITY_FLIP_YOUR_CARD_TEXT")}</InfoText>
      </ContentWrapper>
      <FileSelector
        name="proofOfIdentity"
        type="nationalId"
        selectFiles={selectFiles}
        description="back"
        redirect={`${baseUrl}/proofOfIdentity/upload-back`}
      >
        {text("CONTINUE")}
      </FileSelector>
    </PageWrapper>
  )
}
